import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import { Button, CircularProgress, Card } from "@mui/material";

const BataSettingsCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);


    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [gstError, setGstError] = useState('');

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;

        const updatedFormData = {
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        };

        setFormData(updatedFormData);
    };


    const submitData = async () => {
        try {
            // Update UpdatedBy field in each selected item
            const updatedItems = selectedItems.map(item => ({
                ...item,
                CreatedBy: userId, // assuming userId is defined in your scope
            }));

            // Submit data
            const response = await postData('BataSettingApi', updatedItems, token);
            console.log('Data Created successfully:', response);

            history.push('/BataSettingsIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };


    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [dropdownDepartmentOptions, setDropdownDepartmentOptions] = useState([]);

    const [selectedDesignation, setSelectedDesignation] = useState("");
    const [dropdownDesignationOptions, setDropdownDesignationOptions] = useState([]);

    useEffect(() => {
        fetchDropdownDepartmentOptions();
        fetchDropdownDesignationOptions();
    }, []);

    const fetchDropdownDepartmentOptions = () => {
        fetchData('DepartmentApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDepartmentOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Department dropdown options:', error);
            });
    };

    const fetchDropdownDesignationOptions = () => {
        fetchData('DesignationApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDesignationOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Designation dropdown options:', error);
            });
    };
    const [selectedItems, setSelectedItems] = useState([]);
    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleCalculation = (e, index, inputType) => {
        let name, value;

        // ✅ Determine input name and value (from event or direct call)
        if (typeof e === "object" && e?.target) {
            name = e.target.name;
            value = parseFloat(e.target.value) || 0;
        } else {
            name = inputType;
            value = parseFloat(e) || 0;
        }

        setSelectedItems((prevDetails) => {
            const updatedDetails = [...prevDetails];

            // ✅ Clone the current row/item safely
            const currentItem = { ...updatedDetails[index] };

            // ✅ Update the changed field
            currentItem[name] = value;

            // ✅ Update array with modified item
            updatedDetails[index] = currentItem;

            return updatedDetails;
        });
    };

    // ✅ Fetch slab details function
    const fetchSlabDetails = async (departmentId, designationId) => {
        try {
            if (!departmentId || !designationId) return;

            const response = await fetchData('BataSettingApi', `/BataSlab/${companyId}/${departmentId}/${designationId}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                // ✅ Store the data
                setSelectedItems(data);

            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }

        } catch (error) {
            console.error("Error fetching slab details:", error);
        }
    };

    // ✅ Auto-fetch when both dropdowns are selected
    useEffect(() => {
        if (selectedDepartment && selectedDesignation) {
            fetchSlabDetails(selectedDepartment, selectedDesignation);
        }
    }, [selectedDepartment, selectedDesignation]);


    return (
        <Fragment>
            {/* Top Header Section */}

            <div className=" flex justify-between items-center" style={{ marginTop: '-10px' }}>
                <h6 className='block uppercase tracking-wide text-blue-500 productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    Bata Settings
                </h6>

                <div className="flex gap-2">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={submitData}
                        disabled={isLoading}
                        sx={{ borderRadius: "8px", height: "26px" }}
                    >
                        {isLoading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "💾 Save"
                        )}
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        component={Link}
                        to="/BataSettingsIndex"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        sx={{ borderRadius: "8px", height: "26px" }}
                    >
                        ← Back
                    </Button>
                </div>
            </div>

            {/* Message Section */}
            {errorMessage && (
                <p className="text-red-500 mt-2 font-medium">{errorMessage}</p>
            )}
            {successMessage && (
                <p className="text-green-600 mt-2 font-medium">{successMessage}</p>
            )}


            {/* Main Form Card */}
            <Card
                sx={{
                    mt: 3,
                    p: 3,
                    borderRadius: 3,
                    boxShadow: 3,
                    border: "1px solid #e0e0e0",
                    background: "#fafbfc",
                    marginTop: '2.5px'
                }}
            >
                {/* Section 1 - Basic Info */}
                <div className="mb-6 overflow-x-auto">
                    <div className="w-full mb-2 flex">
                        {/* Department */}
                        <div className="w-2/6 mr-2">
                            <div className="flex items-center">
                                <label
                                    className="block tracking-wide text-black text-xs mr-2"
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    Department
                                </label>
                                <select
                                    className="border rounded w-full focus:shadow-outline custom-select fade-in"
                                    value={selectedDepartment}
                                    style={{
                                        height: "26px",
                                        fontSize: "13px",
                                        padding: "0 6px",
                                        lineHeight: "1.2",
                                        flex: "1",
                                    }}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        const selectedDept = dropdownDepartmentOptions.find(
                                            (dept) => dept.Id.toString() === selectedValue
                                        );

                                        setSelectedDepartment(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            DepartmentId: selectedValue,
                                            DepartmentName: selectedDept ? selectedDept.Name : "",
                                        }));

                                        // ✅ Trigger the fetch after updating state
                                        if (selectedValue) {
                                            fetchSlabDetails(selectedValue, selectedDesignation);
                                        }
                                    }}
                                >
                                    <option value="">Department</option>
                                    {dropdownDepartmentOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Designation */}
                        <div className="w-2/6 mr-2">
                            <div className="flex items-center">
                                <label
                                    className="block tracking-wide text-black text-xs mr-2"
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    Designation
                                </label>
                                <select
                                    className="border rounded w-full focus:shadow-outline custom-select fade-in"
                                    value={selectedDesignation}
                                    style={{
                                        height: "26px",
                                        fontSize: "13px",
                                        padding: "0 6px",
                                        lineHeight: "1.2",
                                        flex: "1",
                                    }}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        const selectedDesig = dropdownDesignationOptions.find(
                                            (dept) => dept.Id.toString() === selectedValue
                                        );

                                        setSelectedDesignation(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            DesignationId: selectedValue,
                                            DesignationName: selectedDesig ? selectedDesig.Name : "",
                                        }));

                                        // ✅ Trigger the fetch after updating state
                                        if (selectedValue) {
                                            fetchSlabDetails(selectedDepartment, selectedValue);
                                        }
                                    }}
                                >
                                    <option value="">Designation</option>
                                    {dropdownDesignationOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Data Table */}
                <div
                    style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        marginBottom: "13px",
                        border: "1px solid #999",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                    }}
                >
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontSize: "13px",
                            fontFamily: "monospace",
                        }}
                    >
                        <thead style={{ backgroundColor: "#1F2A38", color: "#FFFFFF" }}>
                            <tr>
                                {[
                                    "SL.No",
                                    "Shift",
                                    "Bata",
                                ].map((header, idx) => (
                                    <th
                                        key={idx}
                                        style={{
                                            padding: "3px",
                                            textAlign: idx > 1 ? "center" : "left",
                                            borderBottom: "1px solid #ccc",
                                            textTransform: 'uppercase',
                                            fontSize: '10px'
                                        }}                                >
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? "#FDFDFD" : "#F5F7FA",
                                        borderBottom: "1px solid #ddd",
                                    }}
                                >
                                    {/* SL.No + Delete */}
                                    <td style={{ padding: "4px 6px", textAlign: "left" }}>
                                        {index + 1}
                                    </td>

                                    {/* WorkShift Name */}
                                    <td
                                        style={{
                                            fontSize: "13px",
                                            //fontWeight: "bold",
                                            padding: "4px",
                                            minWidth: "200px",
                                        }}
                                    >
                                        {item.WorkShiftName}
                                    </td>

                                    {/* BataAmount */}
                                    <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                        <input
                                            type="number"
                                            value={item.BataAmount}
                                            name="BataAmount"
                                            onChange={(e) => handleCalculation(e, index, "BataAmount")}
                                            style={{
                                                width: "100%",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                                border: "1px solid #bbb",
                                                borderRadius: "3px",
                                                padding: "2px",
                                            }}
                                        />
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Footer */}
                <div className="text-center text-sm text-gray-500 mt-6 border-t pt-2">
                    <CopyrightIcon
                        fontSize="small"
                        className="inline-block text-gray-400 mr-1"
                    />
                    <b className="font-serif">EFFTABS SOLUTIONS LLP</b>
                </div>
            </Card>
        </Fragment>
    );
};

export default BataSettingsCreate;

